import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { ModalTransaction } from '../../../enums/organization-transction.enum';
import { ActivityPackType, ActivityWorkFlowHierarchy, Activitypacktypestatusfunctions } from '../../../models/instance/activity-pacck-type.model';
import { CreateViewWorkflowStatusComponent } from '../../modals/organization/create-view-workflow-status/create-view-workflow-status.component';
import { ManagementApiService } from './../../../../../services/management-api.service';
import { AppConstants } from 'src/app/constants/appconstants';

@Component({
    selector: 'app-instance-activity-workflow',
    templateUrl: './instance-activity-workflow.component.html',
    styleUrls: ['./instance-activity-workflow.component.scss'],
    standalone: false,
})
export class InstanceActivityWorkflowComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild(MatStepper) $stepper: MatStepper;
    @ViewChild('activityPackList') activityPackListElement: ElementRef;

    isLinear = false;
    tooltip_position = 'above';
    formGroup: UntypedFormGroup;
    form: UntypedFormArray;
    displayWorkflow: boolean;
    activityPackTypes: ActivityPackType[];
    destroy$ = new Subject();
    activityPacks: ActivityPackType[];
    isDisableAddButton = false;
    selectedActivityPackType: ActivityPackType; // * currently selected activity pack type
    currentWorkflowSteps: ActivityWorkFlowHierarchy[]; // * this is the workflow steps oreders
    result: ActivityWorkFlowHierarchy[];
    payload: ActivityWorkFlowHierarchy[];
    isWorkflowOrderChange: boolean;
    initialWorkFlowState: ActivityWorkFlowHierarchy[];
    activitypacktypestatusfunctionsList: Activitypacktypestatusfunctions[];

    constructor(
        private cd: ChangeDetectorRef,
        private instanceDataService: InstanceDataService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService,
        private user_utlity: UserUtilityService,
        private ngbModal: NgbModal,
        private customToastService: CustomToastService
    ) {
        this.displayWorkflow = false;
        this.currentWorkflowSteps = [];
        this.payload = [];
        this.isWorkflowOrderChange = false;
    }

    ngOnInit() {
        this.instanceDataService.activityPackTypeList.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.activityPackTypes = res.filter((m) => m.isSelected == true);
            }
        });
        this.getactivitypacktypestatusfunctions();

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_activityWorkflow) {
                this.nextButtonClick();
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_activityWorkflow) {
                this.navigateBack();
            }
        });
    }

    ngAfterViewInit() {
        if (this.displayWorkflow) {
            // this.stepper._getIndicatorType = () => 'number';
            this.stepper.reset();
            this.cd.detectChanges();
        }
    }

    // * add status to workflow steps
    addWorkFlowStatus(index: number) {
        let dialogRef = this.ngbModal.open(CreateViewWorkflowStatusComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.activityPackName = this.selectedActivityPackType.name;
        dialogRef.componentInstance.indexOfStatus = index;
        dialogRef.componentInstance.modalMode = ModalTransaction.ADD;
        dialogRef.componentInstance.workFlowStatus = null;
        dialogRef.componentInstance.currentActivityPack = JSON.parse(JSON.stringify(this.selectedActivityPackType)); // * JSON parse is used to remove direct object refernece
        this.currentWorkflowSteps.forEach((item) => {
            item.next = [];
        });
        dialogRef.componentInstance.currentWorkflowSteps = JSON.parse(JSON.stringify(this.currentWorkflowSteps));
        dialogRef.componentInstance.workflowStatusTypes = this.instanceDataService.workflowStatusTypes;
        dialogRef.componentInstance.activitypacktypestatusfunctionsList = this.activitypacktypestatusfunctionsList;
        dialogRef.result.then(async (result) => {
            if (result) {
                this.ngxUiLoaderService.start();
                let activityPackResponse = await this.getActivityPackById(this.selectedActivityPackType.activityPackTypeId);
                this.ngxUiLoaderService.stop();
                if (activityPackResponse.success) {
                    this.selectedActivityPackType = activityPackResponse.response; // * updating selected activity pack type
                    this.updateNecessaryProperties(activityPackResponse.response);
                } else if (activityPackResponse.isCustom) {
                    // TODO error message
                }
            }
        });
    }

    // * load workflow hierarchy
    loadWorkflow(activityPackTypeId: string) {
        if (this.isWorkflowOrderChange) {
            // TODO show dialog weather to save the changes or not
            let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
                size: 'sm',
                keyboard: false,
                backdrop: 'static',
            });
            dialogRef.componentInstance.modalMessage = 'Do you want to save the changes?';
            dialogRef.result.then((res) => {
                if (res) {
                    this.selectedActivityPackType.activityWorkFlow = this.payload;
                    this.saveWorkflowItem(this.selectedActivityPackType);
                } else {
                    this.payload = [];
                    this.isWorkflowOrderChange = false;
                    this.rendereWorkflowData(activityPackTypeId);
                }
            });
        } else {
            // TODO load the respective workflow
            this.rendereWorkflowData(activityPackTypeId);
        }
    }

    // * loadworkflow steps
    rendereWorkflowData(activityPackTypeId: string) {
        this.currentWorkflowSteps = []; // * clearing temp result on every selection
        this.result = [];
        this.selectedActivityPackType = this.activityPackTypes.find((pack) => pack.activityPackTypeId == activityPackTypeId);
        this.currentWorkflowSteps = this.generateWorkflowOrder(
            this.selectedActivityPackType?.activityWorkFlow ? JSON.parse(JSON.stringify(this.selectedActivityPackType?.activityWorkFlow)) : []
        );
        this.initialWorkFlowState = this.currentWorkflowSteps.slice();
        this.displayWorkflow = true;
    }

    // * view workflow status
    viewWorkFlowStatus(workflowStatus: ActivityWorkFlowHierarchy) {
        let dialogRef = this.ngbModal.open(CreateViewWorkflowStatusComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.workFlowStatus = JSON.parse(JSON.stringify(workflowStatus)); // * JSON parse is used to remove direct object refernece
        dialogRef.componentInstance.currentActivityPack = JSON.parse(JSON.stringify(this.selectedActivityPackType)); // * JSON parse is used to remove direct object refernece
        dialogRef.componentInstance.activityPackName = this.selectedActivityPackType.name;
        dialogRef.componentInstance.modalMode = ModalTransaction.UPDATE;
        dialogRef.componentInstance.workflowStatusTypes = this.instanceDataService.workflowStatusTypes;
        dialogRef.componentInstance.currentWorkflowSteps = JSON.parse(JSON.stringify(this.currentWorkflowSteps));
        dialogRef.componentInstance.activitypacktypestatusfunctionsList = this.activitypacktypestatusfunctionsList;
        dialogRef.result
            .then(async (res) => {
                if (res) {
                    this.ngxUiLoaderService.start();
                    let activityPackResponse = await this.getActivityPackById(this.selectedActivityPackType.activityPackTypeId);
                    this.selectedActivityPackType = activityPackResponse.response; // * updating selected activity pack type
                    this.ngxUiLoaderService.stop();
                    this.updateNecessaryProperties(activityPackResponse.response);
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    // * api call to get the activity pack by instanceId
    getActivityPackByInstanceId(instanceId: string) {
        this.ngxUiLoaderService.start();
        this.managementApiService.getActivityPackByInstanceId(instanceId).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success === true) {
                    this.activityPacks = res.response.filter((item) => item.isSelected === true);
                } else {
                    this.user_utlity.errorModelPopup(res.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                // TODO: Display error toast
            }
        );
    }

    // * api call to save/update the workflow item
    saveWorkflowItem(activityPack: ActivityPackType) {
        this.ngxUiLoaderService.start();
        this.managementApiService.updateActivityPackType(activityPack.instanceId, [activityPack]).subscribe(
            async (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    // TODO toast message
                    this.customToastService.successToast('Workflow Saved Successfully!', 'Success');
                    let response = await this.getActivityPackById(activityPack.activityPackTypeId); // * updating the actvity with latest data
                    this.selectedActivityPackType = response.response; // * updating selected activity pack type
                    this.updateNecessaryProperties(response.response);
                    this.instanceDataService.instanceNavigationHandler(12);
                } else if (res.isCustom) {
                    // TODO Error popup message
                    this.customToastService.errorToast(res?.message || "Something went wrong , Please try again or contact administrator'", 'Error');
                }
            },
            (err) => {
                // TODO Error Toast
                this.customToastService.errorToast("Something went wrong , Please try again or contact administrator'", 'Error');
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // * rearrange handlers
    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.currentWorkflowSteps, event.previousIndex, event.currentIndex);
        this.currentWorkflowSteps.forEach((item) => {
            item.next = [];
        });
        this.payload = [];
        this.generateWorkflow(this.currentWorkflowSteps);
        this.isWorkflowOrderChange = !(JSON.stringify(this.currentWorkflowSteps) === JSON.stringify(this.initialWorkFlowState));
    }

    // * helper to delete the workflow status from hierarchy
    deleteWorkflowStatus(workflowStatus: ActivityWorkFlowHierarchy) {
        let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
            size: 'sm',
            backdrop: 'static',
            keyboard: false,
        });
        dialogRef.componentInstance.modalMessage = `<p>Are you sure you want to delete workflow status <b>${workflowStatus.activityPackTypeStatus.name}</b>?</p>`;
        dialogRef.result.then((res) => {
            if (res) {
                // TODO delete the workflow status
                let index = this.currentWorkflowSteps.findIndex((workflowStep) => workflowStep.activityWorkFlowId == workflowStatus.activityWorkFlowId);
                if (index !== -1) {
                    let workflowStepsCopy = this.currentWorkflowSteps.slice();
                    workflowStepsCopy.splice(index, 1);
                    workflowStepsCopy.forEach((item) => {
                        item.next = [];
                    });
                    this.payload = [];
                    this.generateWorkflow(workflowStepsCopy);
                    this.selectedActivityPackType.activityWorkFlow = this.payload;
                    this.ngxUiLoaderService.start();
                    this.managementApiService.updateActivityPackType(this.selectedActivityPackType.instanceId, [this.selectedActivityPackType]).subscribe(
                        async (res) => {
                            this.ngxUiLoaderService.stop();
                            if (res.success) {
                                this.currentWorkflowSteps.splice(index, 1);
                                this.customToastService.successToast('Worflow status deleted successfully!', 'Success');
                                let response = await this.getActivityPackById(this.selectedActivityPackType.activityPackTypeId); // * updating the actvity with latest data
                                this.selectedActivityPackType = response.response; // * updating selected activity pack type
                                this.updateNecessaryProperties(response.response);
                            } else if (res.isCustom) {
                                this.user_utlity.errorModelPopup(res.message);
                            }
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
                }
            }
        });
    }

    // * api to get activitypack by activityPackID
    getActivityPackById(activityPackId: string) {
        if (activityPackId) {
            return this.managementApiService.getActivityPackByActivityPackId(activityPackId).toPromise();
        }
    }

    // * helper method to generate workflow order
    generateWorkflowOrder(activitypackWorkflow: ActivityWorkFlowHierarchy[]) {
        // let result = [];
        if (activitypackWorkflow.length > 0) {
            activitypackWorkflow.forEach((item) => {
                if (item.hasOwnProperty('next')) {
                    // this.currentWorkflowSteps.push(item);
                    this.result.push(item);
                    this.generateWorkflowOrder(item.next);
                } else {
                    // this.currentWorkflowSteps.push(item);
                    this.result.push(item);
                }
            });
        }
        return this.result;
    }

    // * update specific properties
    updateNecessaryProperties(activityPackType: ActivityPackType) {
        let index = this.activityPackTypes.findIndex((item) => item.activityPackTypeId == activityPackType.activityPackTypeId);
        this.result = [];
        let activtyWorkflowSteps = this.generateWorkflowOrder(activityPackType.activityWorkFlow);
        this.currentWorkflowSteps = activtyWorkflowSteps;
        this.initialWorkFlowState = activtyWorkflowSteps.slice();
        if (index !== -1) {
            this.activityPackTypes[index] = activityPackType;
        }
        this.isWorkflowOrderChange = false;
    }

    // * helper method to generte the activity workflow object
    generateWorkflow(workflowSteps: ActivityWorkFlowHierarchy[]) {
        let zeroIndex = 0;
        workflowSteps.forEach((statusItem, pos) => {
            if (pos == 0) {
                this.payload.push(statusItem);
            }
            let temp: any;
            if (pos > 0) {
                for (let x = 0; x < pos; x++) {
                    if (x == 0) {
                        temp = this.payload[zeroIndex];
                    } else {
                        if (Object.prototype.toString.call(temp) == '[object Array]') {
                            temp = temp[zeroIndex].next;
                        } else {
                            temp = temp.next;
                        }
                    }
                }
            }
            if (pos !== 0) {
                if (Object.prototype.toString.call(temp) == '[object Array]') {
                    temp[zeroIndex].next.push(statusItem);
                } else {
                    temp.next.push(statusItem);
                }
            }
        });
    }

    getactivitypacktypestatusfunctions() {
        this.managementApiService.getactivitypacktypestatusfunctions().subscribe(
            (resp) => {
                if (resp.success) {
                    this.activitypacktypestatusfunctionsList = resp.response;
                } else {
                    this.user_utlity.errorModelPopup(resp.message);
                }
            },
            (err) => {
                this.user_utlity.errorModelPopup(err.message);
            }
        );
    }

    nextButtonClick() {
        if (this.isWorkflowOrderChange) {
            this.selectedActivityPackType.activityWorkFlow = this.payload;
            this.saveWorkflowItem(this.selectedActivityPackType);
        } else {
            this.instanceDataService.instanceNavigationHandler(12); // * navigation to next tab
        }
    }

    navigateBack() {
        this.instanceDataService.instanceNavigationHandler(13);
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
